// import request from "../utils/request";

// export const BACKEND_URL = "https://aaa.sikara.asia";
export const BACKEND_URL =
  'https://gebc.lee-sikaha.cloudns.ch';
export const GAMEKEE_IMG_URL =
  'gamekee.luckluck.dpdns.org/gamekee';
